import { render } from "./LanguageComponent.vue?vue&type=template&id=92c07526&scoped=true"
import script from "./LanguageComponent.vue?vue&type=script&lang=js"
export * from "./LanguageComponent.vue?vue&type=script&lang=js"

import "./LanguageComponent.vue?vue&type=style&index=0&id=92c07526&lang=scss&scoped=true"

import exportComponent from "/workspace/source/scm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92c07526"]])

export default __exports__